module.exports = __webpack_public_path__ + "media/images/banners/slide-1-a86f3ced2f8bb88c6121060bf5d99447.jpg";